<template>
    <div class="w-full bg-branding-light-grey rounded-full overflow-hidden h-2">
        <div
            class="rounded-l-full bg-branding-brand-yellow h-full"
            :style="`width : ${percentage}%`"
        ></div>
    </div>
</template>

<script lang="ts" setup>
    defineProps<{
        percentage: number;
    }>();
</script>
